// extracted by mini-css-extract-plugin
export default {"container":"bs-z","heading":"cs-z","text":"ds-z","info":"es-z","link":"fs-z","fullMaxWidth":"gs-z"};